import { useAtomValue } from 'jotai';
import { DocumentResponse } from 'types/api-responses';
import { useStatesAtom } from './atoms';
import { resourcesAtom } from 'atoms/root';
import { EMPTY_CELL } from 'utils/empty-cell';

export const CountyName = ({
  county,
}: {
  county: DocumentResponse['county'];
}) => {
  const resources = useAtomValue(resourcesAtom);
  const statesAtom = useStatesAtom(resources?.states.href);
  const states = useAtomValue(statesAtom);
  if (county) {
    if (states.data && 'error' in states.data) return null;
    const state = states.data?.find((state) => state.id === county.stateId);
    return <>{`${county.name}, ${state?.name || county.state.abbreviation}`}</>;
  } else {
    return <>{EMPTY_CELL}</>;
  }
};
